// tslint:disable: max-line-length
import * as React from "react";
import SvgIcon from "material-ui/SvgIcon";

export const LeftArrow: React.FunctionComponent<any> = (props) => {
    return (
        <SvgIcon width="14" height="10" viewBox="0 0 14 10" {...props}>
            <g fill="none" fillRule="evenodd">
                <path d="M-2-4h18v18H-2z" />
                <path
                    stroke="#585858"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    d="M13 5H1M5 9L1 5l4-4"
                />
            </g>
        </SvgIcon>
    );
};
